<template>
    <section>
        <Sidebar />
        <Content class="create-endpoint-page">
            <h1><i class="fas fa-bell" style="margin-right: 7px;"></i> Alerts</h1>
            <b-notification type="is-info" class="hide">
                <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i> You have not subscribed yet. Choose a plan and start using Devect
            </b-notification>
            <div class="col-md-4" style="margin-bottom: 50px;">
                <b-field label="Email">
                    <div class="row">
                        <div class="col-xs-12">
                            <b-switch v-model="settings.email_notification" type="is-success" style="float: left; margin-top: 6px;"></b-switch>
                            <b-input type="email" ref="email" v-model="settings.email" required style="float: left; clear: none;"></b-input>
                        </div>
                    </div>
                </b-field>
                <b-field label="Phone number" class="hide">
                    <div class="row">
                        <div class="col-sm-12">
                            <b-switch v-model="settings.sms_notification" type="is-success" style="float: left; margin-top: 6px;"></b-switch>
                            <b-input type="text" ref="phone" v-model="settings.phone" style="float: left; clear: none;"></b-input>
                        </div>
                    </div>
                </b-field>
                <b-button type="is-primary" style="margin-top: 20px;" @click="updateSettings()">Save</b-button>
            </div>
            <div class="col-md-8">
                <b-table
                    :data="data.length == 0 ? [] : data"
                    :bordered="true"
                    :striped="true"
                    :loading="isLoading">

                    <template slot-scope="props">
                        <b-table-column field="Type" label="Type" width="40" numeric>
                            <span>Email</span>
                        </b-table-column>

                        <b-table-column field="To" label="To">
                            {{ props.row.notification_to }}
                        </b-table-column>

                        <b-table-column field="date" label="Date" centered>
                            <small>{{new Date(props.row.created).toLocaleDateString()}}
                            {{new Date(props.row.created).toLocaleTimeString()}}</small>
                        </b-table-column>
                    </template>

                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                        icon="emoticon-sad"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import {getJWTContent, getUserPlan} from "../logic/global"
import constants from '../constants'
import Plans from '../components/Plans'
import {getUserNotificationsSettings, updateUserNotificationsSettings, getUserAlerts} from '../logic/account'



let settings = {
    "user": null,
    "email_notification": true,
    "sms_notification": false,
    "call_notification": false,
    "email": "",
    "phone": ""
}

export default {
    name: 'Alerts',
    components: {Sidebar, Content, Plans},
    data() {
        return {
            user_plan: null,
            plan_limitations: null,
            settings: settings,
            isLoading: true,
            data: [],
        }
    },
    methods: {
       getSettings: function(){
            let user_id = getJWTContent()["id"]
            getUserNotificationsSettings(user_id).then(response => {
                this.settings = response.data
            }).catch(error => {
                this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
       },
       getAlerts: function(){
            this.isLoading = false
            let user_id = getJWTContent()["id"]
            getUserAlerts(user_id).then(response => {
                this.data = response.data
            }).catch(error => {
                this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
       },
       updateSettings: function(){
            let user_id = getJWTContent()["id"]
            updateUserNotificationsSettings(user_id, this.settings).then(response => {
                this.showSuccessMsg("Settings updated successfully", "is-success")
            }).catch(error => {
                this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
       },
        showSuccessMsg: function(message, msg_type, duration=2000){
            this.$buefy.toast.open({message: message, type: msg_type, duration: duration})
        },
    },
    mounted: function(){
        getUserPlan().then(response => {
            this.user_plan = response.data
            this.plan_limitations = constants.PLANS_LIMITATIONS[this.user_plan.plan]
        })
        this.getSettings();
        this.getAlerts();
    }
}
</script>

<style scoped>
  h1{margin-bottom: 24px;}
</style>